import React, { useEffect, useState } from 'react';

import styles from './modal.module.scss';


interface ModalProps {
    onClose: () => void;
    header: string;
    footer?: string;
    hidden: boolean;
    children: JSX.Element;
    delayInSeconds?: number;
    singleUse?: boolean;
}

const Modal: React.FC<ModalProps> = ({ onClose, singleUse, children, header, footer, hidden = true, delayInSeconds }) => {

    const [internalHidden, setInternalHidden] = useState<boolean>(true);
    const [disabled, setDisabled] = useState<boolean>(false);

    const handleOnClick = () => {
        setInternalHidden(true);
        if (singleUse) {
            setDisabled(true);
        }
        onClose();
    }

    const seconds = delayInSeconds ?? 5

    useEffect(() => {
        const timer = setTimeout(() => {
            setInternalHidden(hidden);
        }, seconds * 1000)

        return () => clearTimeout(timer);
    }, [delayInSeconds, hidden])

    if (disabled) {
        return null;
    }

    if (hidden) {
        return null;
    }

    if (internalHidden) {
        return null;
    }
    return (
        <div className={`${styles.modal} ${styles.modal_delay}`} onClick={handleOnClick} >
            <div className={styles.modal_content} onClick={(e)=>{
                //prevent click from passing to parent
                e.stopPropagation();
            }}>
                <div className={styles.modal_header}>
                    <span className={styles.close} onClick={handleOnClick}>&times;</span>
                    <h2>{header}</h2>
                </div>
                <div className={styles.modal_body}>
                    {children}
                </div>
                {footer &&
                    <div className={styles.modal_footer}>
                        <h3>{footer}</h3>
                    </div>
                }
            </div>
        </div>
    );
};

export default Modal;